import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "../pages/start/login/login.page";
import RegistrationPage from "../pages/start/registration/registration.page";
import RegistrationCustomersPage from "../pages/start/registration/registration-customers/registration-customers.page";
import BookingPage from '../pages/customers/booking/booking.page';
import ReservationListPage from '../pages/customers/reservation-list/reservation-list.page';
import LandingPage from "../pages/customers/landing-page/landing.page";
import PrivateRoute from "./PrivateRoute";
import AllEventsPage from '../pages/admin/all-events/all-events.page';
import ReservationListAdminPage from '../pages/admin/reservation-list-admin/reservation-list-admin.page';
import HandleReservationPage from '../pages/admin/handle-reservation/handle-reservation.page';
import ChangePasswordPage from "../pages/shared/change-password/change-password.page";
import ResetPasswordPage from "../pages/shared/reset-password/reset-password.page";
import AdminNewReservationPage from "../pages/admin/admin-new-reservation/admin-new-reservation.page"
import ConfirmResetPasswordPage from '../pages/shared/complete-reset-password/complete-reset-password.page';
import EditProfilePage from '../pages/customers/edit-profile/edit-profile.page';
import RoomsListPage from '../pages/customers/rooms-list/rooms-list.page';
import ListAttendeesPage from "../pages/customers/list-attendees/list-attendees.page";
import EventsListAdminPage from '../pages/admin/events-list-admin/events-list-admin.page';

const Router = () => {

  return (
    <Routes>
      <Route path="*" element={<p>Pagina non trovata</p>} />
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registration" element={<RegistrationPage />} />
      <Route path="/registration-customer" element={<RegistrationCustomersPage />} />
      <Route path="/customer/booking/:id?" element={<PrivateRoute><BookingPage /></PrivateRoute>} />
      <Route path="/customer/rooms" element={<PrivateRoute><RoomsListPage /></PrivateRoute>} />
      <Route path="/customer/reservation-list" element={<PrivateRoute><ReservationListPage /></PrivateRoute>} />
      <Route path="/customer/edit-profile" element={<PrivateRoute><EditProfilePage /></PrivateRoute>} />
      <Route path="/customer/list-attendees/:id?" element={<PrivateRoute><ListAttendeesPage /></PrivateRoute>} />
      <Route path="/admin/all-events" element={<PrivateRoute><AllEventsPage /></PrivateRoute>} />
      <Route path="/admin/events-list/" element={<PrivateRoute><EventsListAdminPage /></PrivateRoute>} />
      <Route path="/admin/reservation-list-admin" element={<PrivateRoute><ReservationListAdminPage /></PrivateRoute>} />
      <Route path="/admin/handle-reservation-admin/:id?" element={<PrivateRoute><HandleReservationPage /></PrivateRoute>} />
      <Route path="/admin/admin-new-reservation" element={<PrivateRoute><AdminNewReservationPage /></PrivateRoute>} />
      <Route path="/change-password/" element={<PrivateRoute><ChangePasswordPage /></PrivateRoute>} />
      <Route path="/complete-registration/:id?" element={<RegistrationCustomersPage />} />
      <Route path="/reset-password/" element={<ResetPasswordPage/>} />
      <Route path="/login/reset_password" element={<ConfirmResetPasswordPage/>} />
    </Routes>
  )
}

export default Router
